import { useTranslations } from "use-intl";
import { useAppLocale } from "../i18n";
import { nexaLegalLinks } from "../lib/legal-links";
import { CaseflowContactButton } from "./CaseflowContactButton";

export const SiteFooter = ({ dark = false, note }: { dark?: boolean; note?: string }) => {
  const t = useTranslations("siteFooter");
  const { locale } = useAppLocale();
  const urls = nexaLegalLinks(locale);
  const links = [
    { label: t("operator"), href: urls.operator },
    { label: t("privacy"), href: urls.privacy },
    { label: t("terms"), href: urls.terms },
  ];

  return (
    <footer className={`site-footer${dark ? " site-footer--dark" : ""}`}>
      <div className="site-footer-brand">
        <strong>FlowTrace</strong>
        <small>© {new Date().getFullYear()} NexA LLC.</small>
      </div>
      <nav aria-label={t("navigation")} data-testid="legal-links">
        {links.map(({ href, label }) => (
          <a href={href} key={href} rel="noopener noreferrer" target="_blank">
            {label}
            <span aria-hidden="true" className="site-footer-arrow">↗</span>
            <span className="sr-only"> {t("newTab")}</span>
          </a>
        ))}
      </nav>
      <CaseflowContactButton />
      {note && <p className="site-footer-note">{note}</p>}
    </footer>
  );
};
